const imageList = [
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-1.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-2.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-3.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-4.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-5.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-6.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-7.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-8.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/image-9.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/1.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/2.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/3.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/4.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/5.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/6.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/7.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/8.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/9.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/10.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/11.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/12.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/13.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/14.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/15.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/16.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/17.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/18.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/19.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/20.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/21.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/22.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/23.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/24.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/25.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/26.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/27.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/28.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/29.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/30.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/31.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/32.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/33.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/34.jpg"
    },
    {
        name: "Life at Delveinsight",
        imagSrc: "img/careers/jpg/35.jpg"
    },
]

export {
    imageList
}